export default function getSubmitLabel (isEdit, isEditLoading, formName, isAddLoading)  {
  if (isEdit) return isEditLoading ? "Updating..." : `Update ${formName}`;
  return isAddLoading ? "Saving..." : `Save ${formName}`;
};
